/**
 * ========================================
 * CUSTOM JAVASCRIPT: GSAP Horizontal Scroll Animation
 * Purpose: Enable horizontal scrolling hero section
 * Created: January 2026
 * Dependencies: GSAP 3.12.5, ScrollTrigger plugin (loaded via CDN)
 * ========================================
 */

(function() {
  'use strict';

  // === CUSTOM: Initialize Horizontal Scroll Animation ===
  function initHorizontalScroll() {
    const sections = document.querySelectorAll('.horizontal-scroll-section');
    
    sections.forEach((section) => {
      const container = section.querySelector('.horizontal-scroll-container');
      const panels = gsap.utils.toArray('.scroll-panel', section);
      
      if (panels.length === 0) return;
      
      // Use a function-based value for 'x' and 'end' 
      // This forces GSAP to recalculate the width whenever the window refreshes
      gsap.to(container, {
        x: () => -(container.scrollWidth - window.innerWidth), 
        ease: "none",
        scrollTrigger: {
          trigger: section,
          pin: true,
          scrub: 1,
          // Recalculates the end point based on the updated width
          end: () => "+=" + (container.scrollWidth - window.innerWidth),
          invalidateOnRefresh: true
        }
      });
    });
  }

  // === CUSTOM: Load GSAP Libraries from CDN ===
  function loadGSAP() {
    // Check if GSAP already loaded
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      initHorizontalScroll();
      return;
    }

    // Load GSAP Core Library
    const gsapScript = document.createElement('script');
    gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    gsapScript.async = true;
    
    gsapScript.onload = function() {
      // Load ScrollTrigger Plugin after GSAP loads
      const scrollTriggerScript = document.createElement('script');
      scrollTriggerScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
      scrollTriggerScript.async = true;
      
      scrollTriggerScript.onload = function() {
        // Register ScrollTrigger plugin with GSAP
        gsap.registerPlugin(ScrollTrigger);
        
        // Initialize animation
        initHorizontalScroll();
        
        // === CUSTOM: Refresh ScrollTrigger on window resize ===
        window.addEventListener('resize', () => {
          ScrollTrigger.refresh();
        });
      };
      
      document.head.appendChild(scrollTriggerScript);
    };
    
    document.head.appendChild(gsapScript);
  }

  // === CUSTOM: Initialize when DOM is ready ===
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadGSAP);
  } else {
    loadGSAP();
  }

  // === CUSTOM: Shopify Section Events (for theme editor) ===
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId && typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  });

})();